export const micrositesPartial = `
    microsites: ds_MicrositesEntries {
        __typename
        ... on ds_MicrositeHomepage_Entry {
            uri
        }
        ... on ds_MicrositePage_Entry {
            uri
        }
    }
`